import React from 'react';
import { currencyFormatter } from 'utils/formatter';
import BigNumberDisplay from './BigNumberDisplay';

function percentageMargin(netSales, grossProfit) {
  return isNaN((grossProfit / netSales) * 100)
    ? 0
    : (grossProfit / netSales) * 100;
}

function BigNumbersRow(props) {
  const { grossSales, netSales, grossProfit, totalTransactions } = props;
  const grossMargin = percentageMargin(netSales, grossProfit).toFixed(2);
  return (
    <div className="row">
      <BigNumberDisplay
        linkTo="/reports/sales/summary"
        title="GROSS SALES"
        content={currencyFormatter(grossSales)}
      />

      <BigNumberDisplay
        linkTo="/reports/sales/summary"
        title="NET SALES"
        content={currencyFormatter(netSales)}
      />

      <BigNumberDisplay
        linkTo="/reports/sales/gross_profit"
        title="GROSS PROFIT"
        content={currencyFormatter(grossProfit)}
      />

      <BigNumberDisplay
        linkTo="/reports/sales/payment_methods"
        title="TRANSACTIONS"
        content={totalTransactions}
      />

      <BigNumberDisplay
        linkTo="/reports/transactions"
        title="AVERAGE SALE PER TRANSACTION"
        content={currencyFormatter(netSales / (totalTransactions || 1))}
      />

      <BigNumberDisplay
        linkTo="/reports/sales/gross_profit"
        title="GROSS MARGIN"
        content={`${grossMargin}%`}
      />
    </div>
  );
}

export default BigNumbersRow;
